import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { SUBMIT } from 'app/constants/button'

const ExportCSV = (props) => {
  const { onAction, selectedCount = 0 } = props

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <div>
      <Typography
        className="text-14 font-400 text-primary cursor-pointer"
        onClick={() => handleOpen()}
      >
        {formatMessage({
          id: 'teamMembers.table.action.exportCSV.label',
        })}
      </Typography>

      <SubmitDialog
        id="dialog-export-csv-team-member"
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'exportCSV.title',
        })}
        description={formatMessage(
          {
            id: 'teamMembers.exportCSV.description',
          },
          { selectedCount: selectedCount },
        )}
        submitText={formatMessage({
          id: 'action.export',
        })}
        onSubmit={async () => {
          await onAction()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

ExportCSV.propTypes = {
  onAction: PropTypes.func,
  closeMenu: PropTypes.func,
  className: PropTypes.string,
  selectedCount: PropTypes.number,
}

export default ExportCSV
